export const PAPER_ELEVATION = 2;